import { createStore, applyMiddleware, Store } from "redux";
import { composeWithDevTools } from 'redux-devtools-extension';
import createSagaMiddleware from "redux-saga";

import rootReducer, { IApplicationState } from "../reducers";
import rootSaga from "../sagas";

export default function configureStore() : Store<IApplicationState> {
  const sagaMiddleware  = createSagaMiddleware();
  const store = {
    ...createStore(
      rootReducer,
	  composeWithDevTools(applyMiddleware(sagaMiddleware))
    ),
  };
  sagaMiddleware.run(rootSaga);
  return store;
};